import React from "react";
import { MarginProps } from "styled-system";
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { DriveSlotItem } from "../../types/drive";
import Box from "../Box";
import Slot from "../Slot";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Europe/Paris");

type SlotsBarProps = {
  slots: Array<DriveSlotItem>;
  minStartDateTime: Dayjs;
  maxEndDateTime?: Dayjs;
} & MarginProps;

const SlotsBar = ({ slots, minStartDateTime, maxEndDateTime, ...rest }: SlotsBarProps) => {
  const lastEndDateTime = dayjs(slots.length > 0 ? slots[slots.length - 1].endDateTime : minStartDateTime);
  const fillerMinutes = maxEndDateTime ? maxEndDateTime.diff(lastEndDateTime, "minute") : 0;

  return (
    <Box
      display="flex"
      flexDirection={"column"}
      width={"100%"}
      height={"100%"}
      {...rest}
    >
      {slots.map((slot, index, array) => {
        return (
          <Slot
            data-testid="drive-slot"
            startDateTime={slot.startDateTime}
            endDateTime={slot.endDateTime}
            bookedCount={slot?.bookedCount}
            capacity={slot.capacity}
            status={slot.status}
            slotsCount={array.length}
            minStartDateTime={index !== 0 ? slots[index-1].endDateTime : minStartDateTime}
            key={slot.startDateTime.toISOString() + index}
          />
        );
      })}
      {fillerMinutes > 0 && (
        <Box data-testid="slot-filler" height={(fillerMinutes / 30) * 40} width={"100%"} />
      )}
    </Box>
  );
};

export default SlotsBar;
